import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import {RequestAnalysisCount} from "../../../../domains/models/asset-management";

interface RequestAnalysisChartProps {
    categories: RequestAnalysisCount[];
}

const CustomTooltip = ({active, payload, label}: { active?: boolean; payload?: { name: string; value: number; color: string }[]; label?: string }) => {
    if (!active || !payload || !payload.length) return null;
    return (
        <div
            style={{
                background: '#fff',
                border: '1px solid #E5E7EB',
                borderRadius: 8,
                padding: '10px 14px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                fontFamily: 'DM Sans, sans-serif',
                fontSize: 12,
            }}
        >
            <div style={{fontWeight: 700, marginBottom: 6, color: '#111827'}}>{label}</div>
            {payload.map((entry) => (
                <div key={`tooltip-${entry.name}`}
                     style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3}}>
                    <span style={{
                        width: 8,
                        height: 8,
                        borderRadius: 2,
                        background: entry.color,
                        display: 'inline-block'
                    }}/>
                    <span style={{color: '#6B7280'}}>{entry.name}:</span>
                    <span style={{fontWeight: 600, color: '#111827', marginLeft: 2}}>{entry.value}</span>
                </div>
            ))}
        </div>
    );
};

function RequestAnalysisChart(props: RequestAnalysisChartProps) {
    return (
        <section className="pn-asset__card">
            <div className="pn-asset__card__header">
                <div>
                    <h3 className="pn-asset__card__title">Request Analysis by Category</h3>
                    <span className="pn-asset__card__subtitle">Approved / Rejected / Pending / Cancelled</span>
                </div>
                {/*<span className="pn-asset__card__badge green-badge">Total {props.categories.length} categories</span>*/}
            </div>

            <div className="pn-asset__chart-area">
                <ResponsiveContainer width="100%" height={240}>
                    <BarChart
                        data={props.categories}
                        margin={{top: 8, right: 8, left: -40, bottom: 0}}
                        barSize={10}
                        barGap={1}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false}/>
                        <XAxis
                            dataKey="name"
                            tick={{fontSize: 11, fill: '#9CA3AF', fontFamily: 'DM Sans, sans-serif'}}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis
                            allowDecimals={false}
                            tick={{fontSize: 11, fill: '#9CA3AF', fontFamily: 'DM Sans, sans-serif'}}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip content={<CustomTooltip/>} cursor={{fill: 'rgba(37,99,235,0.04)'}}/>
                        <Legend
                            wrapperStyle={{fontSize: 11, fontFamily: 'DM Sans, sans-serif', paddingTop: 12}}
                            iconType="circle"
                            iconSize={8}
                        />
                        <Bar dataKey="total" name="Total Requests" fill="var(--request-total)" radius={[3, 3, 0, 0]}/>
                        <Bar dataKey="accepted" name="Accepted" fill="var(--request-accepted)" radius={[3, 3, 0, 0]}/>
                        {/*<Bar dataKey="allocated" name="Allocated" fill="#4f46e5" radius={[3, 3, 0, 0]}/>*/}
                        <Bar dataKey="pending" name="Pending" fill="var(--request-pending)" radius={[3, 3, 0, 0]}/>
                        <Bar dataKey="cancelled" name="Cancelled" fill="var(--request-cancelled)" radius={[3, 3, 0, 0]}/>
                        <Bar dataKey="rejected" name="Rejected" fill="var(--request-rejected)" radius={[3, 3, 0, 0]}/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </section>
    );
}

export default RequestAnalysisChart;